import React from "react";
import { shape, func, bool, string } from "prop-types";
// import { Link } from "@quintype/components";

const MenuItem = ({ item, itemClick }) =>
  item.type === "placeholder" ? (
    <span>{item.title}</span>
  ) : (
    <a href={item.completeUrl} rel="noopener noreferrer" onClick={itemClick}>
      {item.title}
    </a>
  );

MenuItem.propTypes = {
  item: shape({
    isExternalLink: bool,
    completeUrl: string,
    title: string
  }),
  itemClick: func
};

export { MenuItem };
